module.exports = __webpack_public_path__ + "static/wedding-web-cover_PLACEHOLDER-6acec850a871b4a61d0d6ea0ebec1004.jpg";